import {
  resolveMobileRuntimeConfig,
  type MobileRuntimeConfig,
} from "../../config/runtime-config.js";

export interface PatientBrand {
  brandName: string;
  assistantName: string;
  poweredByText: string | null;
}

const defaultBrand: PatientBrand = {
  brandName: "AmpleCare",
  assistantName: "Care Assistant",
  poweredByText: null,
};

/**
 * Curated white-label registry. The URL/config key (`acBrand`) selects a
 * brand *key*; display strings only ever come from this table — never from
 * URL-provided text.
 */
const brandRegistry: Record<string, PatientBrand> = {
  vip: {
    brandName: "VIP Surgicare",
    assistantName: "Care Assistant",
    poweredByText: "Powered by AmpleCare",
  },
};

export function resolvePatientBrand(
  runtimeConfig?: Pick<MobileRuntimeConfig, "whiteLabelBrandKey">,
): PatientBrand {
  const config = runtimeConfig ?? resolveMobileRuntimeConfig();
  const key = config.whiteLabelBrandKey;

  if (key != null && brandRegistry[key]) {
    return brandRegistry[key];
  }

  return defaultBrand;
}
